<template>
  <div class="header-container">
    <div class="flex-1 hidden sm:block">
      {{ $route.meta.title }}
    </div>
    <div class="mr-4 sm:mr-8">
      <template v-if="$route.params.isImage">
        <img
          src="../../assets/dark/zoom-in.png"
          class="header-image mr-2"
          @click="$emit('zoomIn')"
        >
        <img
          src="../../assets/dark/zoom-out.png"
          class="header-image mr-16"
          @click="$emit('zoomOut')"
        >
      </template>
      <img
        v-if="$route.params.enableBack"
        src="../../assets/dark/dark-back-button.png"
        class="header-image"
        @click="navigateBack"
      >
    </div>
    <div
      class="header-image"
      @click="$router.push('/')"
    >
      <img src="../../assets/dark/close-window-button.png">
    </div>
  </div>
</template>

<script>
export default {
  name: 'SectionLayoutHeaderDark',

  methods: {
    navigateBack() {
      const from = this.$route.params.from
      if (from) {
        const { name, params } = from
        return this.$router.push({ name, params })
      }

      this.$router.go(-1)
    },
  },
}
</script>

<style lang="postcss" scoped>
.header {
  &-container {
    font-family: 'input-mono';
    font-size: 12px;
    @apply text-blue flex items-center justify-between p-2 bg-almost-black;
  }

  &-image {
    @apply cursor-pointer;
  }
}
</style>
